/**
 * Emitter module.
 * @module utils/emitter
 */

/** Class for emitting custom events */
export default class Emitter {

  /** Create the emitter */
  constructor() {
    this.events = {};
  }

  /** 
   * Bind callback to an event type.
   * @param {String} type - The event type.
   * @param {Function} callback - The function to bind to the event.
   */
  on(type, callback) {
    if(!(type in this.events)) this.events[type] = [];
    this.events[type].push(callback);
  }

  /** 
   * Unbinds a callback from an event type.
   * @param {String} type - The event type.
   * @param {Function} [callback=null] - The function to unbind from the event.
   */
  off(type, callback=null) {
    if (callback && type in this.events) {
      const newList = [];
      for (let cb of this.events[type]) {
        if (cb !== callback) newList.push(cb);
      }
      this.events[type] = newList;
    } else {
      delete this.events[type];
    }
  }

  /** 
   * Triggers an event.
   * @param {String} type - The event type.
   */
  trigger(type) {
    let event = {};
    if (type in this.events) {
      event.type = type;
      for (let cb of this.events[type]) cb.call(this, event);
    }
  }
}



// WEBPACK FOOTER //
// ./source/scripts/utils/emitter.js